import React from 'react';

export const notFoundView = (props) => {
  const { history } = props;
  const backToLogin = () => {
    localStorage.clear();
    history.goBack();
  };
  return (
    <div className='page_access'>
      <h2 className='heading heading__level2'>Page Access not allowed.</h2>
      <button className='btn btn-color' onClick={() => backToLogin()}>
        <i className='fa fa-angle-left btn__icon' />
        Go Back
      </button>
    </div>
  );
};
